import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';

export const Duration = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(20),
  color: theme.palette.text.secondary,
  lineHeight: 1,
  fontWeight: 500,
  marginTop: 16
}));